import { render } from "./card-project-mini.vue?vue&type=template&id=2d8c6a6f&scoped=true"
import script from "./card-project-mini.vue?vue&type=script&lang=js"
export * from "./card-project-mini.vue?vue&type=script&lang=js"

import "./card-project-mini.vue?vue&type=style&index=0&id=2d8c6a6f&lang=scss&scoped=true"

import exportComponent from "/home/mark/Dev/www/Portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8c6a6f"]])

export default __exports__